import AccountCircle from "@mui/icons-material/AccountCircle";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MenuIcon from "@mui/icons-material/Menu";
import MoreIcon from "@mui/icons-material/MoreVert";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { createStyles, makeStyles } from "@mui/styles";
import { spacing } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import isMobile from "../../hooks/isMobile";
import useTheme from "../../hooks/useTheme";
import { APP_NAME } from "../../lib/config";
import { open_drawer } from "../../lib/global";
import { SideNavbarToggleSubject } from "../../lib/rxSubject";
import { removeLocalStorageKey, setLocalStorage } from "../../lib/session";
import { actionThemeChange } from "../../redux/actions/home.action";
import Image from "../Images/Image";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: spacing(2),
  },
  title: {
    display: "none",
    // [theme.breakpoints.up("sm")]: {
    //   display: "block",
    // },
  },
  searchIcon: {
    padding: spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${spacing(4)}px)`,
    // transition: theme.transitions.create("width"),
    width: "100%",
    // [theme.breakpoints.up("md")]: {
    //   width: "20ch",
    // },
  },
  sectionDesktop: {
    display: "none",
    // [theme.breakpoints.up("md")]: {
    //   display: "flex",
    // },
  },
  sectionMobile: {
    display: "flex",
    // [theme.breakpoints.up("md")]: {
    //   display: "none",
    // },
  },
}));

const Headers = () => {
  const dispatch = useDispatch();
  const [theme, themeType] = useTheme();
  const [mobileView] = isMobile();
  const Route = useHistory();
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [minimize, setMinimize] = useState(false);

  useEffect(() => {
    SideNavbarToggleSubject.subscribe((flag) => setMinimize(flag || false));
  }, []);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleThemeChange = () => {
    const newTheme = themeType === "dark" ? "light" : "dark";
    setLocalStorage("theme", newTheme);
    dispatch(actionThemeChange(newTheme));
  };

  const handleLogout = () => {
    handleMenuClose();
    removeLocalStorageKey("token");
    Route.push("/auth");
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {/* <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem> */}
      <MenuItem onClick={handleThemeChange}>
        <IconButton>
          <Brightness4Icon />
        </IconButton>
        {themeType === "dark" ? "Light Theme" : "Dark Theme"}
      </MenuItem>
      <MenuItem onClick={handleLogout}>
        <IconButton>
          <ExitToAppIcon />
        </IconButton>
        <Typography>Logout</Typography>
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {/* <MenuItem>
        <IconButton aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="secondary">
            <MailIcon />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem> */}
      {/* <MenuItem>
        <IconButton aria-label="show 11 new notifications" color="inherit">
          <Badge badgeContent={11} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem> */}
      {/* <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem> */}
      <MenuItem onClick={handleThemeChange}>
        <IconButton>
          <Brightness4Icon />
        </IconButton>
        {themeType === "dark" ? "Light Theme" : "Dark Theme"}
      </MenuItem>
      <MenuItem onClick={handleLogout}>
        <IconButton>
          <ExitToAppIcon />
        </IconButton>
        <Typography>Logout</Typography>
      </MenuItem>
    </Menu>
  );

  // const handleToggleDrawer = () => {
  //   open_drawer("SIDEBAR", {
  //     paperClass: "backNavMenu"
  //   }, 'right')
  // }

  const handleToggleDrawer = () => {
    if (mobileView) {
      open_drawer(
        "SIDEBAR",
        {
          paperClass: "mv_side_navbar",
        },
        "left"
      );
    } else {
      SideNavbarToggleSubject.next(!minimize);
    }
  };

  return (
    // eslint-disable-next-line
    <div
      className={`${classes.grow} main-header ${
        mobileView ? "mobile" : "desktop"
      }`}
    >
      {!mobileView ? (
        <AppBar
          style={{
            backgroundColor: theme.headerBgColor,
          }}
          className={`header_sidebar ${minimize ? "min" : "max"}`}
          position="static"
        >
          <div className="d-flex align-items-center">
            <Image
              src={"/icon.png"}
              height="90%"
              width="74px"
              className="p-3"
              alt="Header logo for admin dashboard"
            />
            <div className="text-start w-100">
              <Typography
                className={(classes.title, "Bold")}
                variant="h6"
                noWrap
              >
                Admin Panel
              </Typography>
            </div>
          </div>
        </AppBar>
      ) : (
        <></>
      )}

      <AppBar
        style={{
          backgroundColor: theme.headerBgColor,
        }}
        className={`header_body ${minimize ? "min" : "max"}`}
        position="static"
      >
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            onClick={handleToggleDrawer}
            color="inherit"
            aria-label="open drawer"
          >
            <MenuIcon />
          </IconButton>
          {mobileView ? (
            <div className="w-100 text-start">
              <h4 className="m-0">{APP_NAME}</h4>
            </div>
          ) : (
            <></>
          )}
          <Typography className={classes.title} variant="h5" noWrap>
            {APP_NAME}
          </Typography>
          {/* <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ 'aria-label': 'search' }}
            />
          </div> */}
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            {/* <IconButton aria-label="show 4 new mails" color="inherit">
              <Badge badgeContent={4} color="secondary">
                <MailIcon />
              </Badge>
            </IconButton> */}

            {/* <IconButton aria-label="show 17 new notifications" color="inherit">
              <Badge badgeContent={17} color="secondary">
                <NotificationsIcon />
              </Badge>
            </IconButton> */}

            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
          </div>

          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </div>
  );
};

export default Headers;
